import { render, staticRenderFns } from "./downloadCenter.vue?vue&type=template&id=1b2729c4&scoped=true"
import script from "./downloadCenter.vue?vue&type=script&lang=js"
export * from "./downloadCenter.vue?vue&type=script&lang=js"
import style0 from "./downloadCenter.vue?vue&type=style&index=0&id=1b2729c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2729c4",
  null
  
)

export default component.exports